import { all, call, put, select } from 'redux-saga/effects';
import { showLoader, hideLoader } from 'store/commons/actions';
import {
  getContractsFiltersService,
  getListOfContractsService,
  postContract,
  getContractDetails,
  postChangeOfVehicle,
  postCreateLoan,
  putContract,
  getManagers,
  getCoordinators,
  getAdminFleets,
  fetchContractVehicles,
  downloadTemplateForVCMassiveLoad,
  uploadVehicles,
  downloadRecords,
  postEditCategorySubcategory,
  downloadVehiclesChangeTemplate,
  uploadMassiveChange,
  downloadMassiveChangeRecords,
} from 'services/contracts';
import { getOptionsAuth } from 'services/auth';
import {
  getContractsSucceed,
  getContractsFailed,
  getContractsFiltersSucceed,
  getContractsFiltersFailed,
  saveContractSucceed,
  saveContractFailed,
  getContractDetailsSucceed,
  getContractDetailsFailed,
  getContractVehicles,
  getContractVehiclesSucceed,
  getContractVehiclesFailed,
  changeOfVehicleSucceed,
  changeOfVehicleFailed,
  createLoanSucceed,
  createLoanFailed,
  updateContractSucceed,
  updateContractFailed,
  getManagersSucceed,
  getManagersFailed,
  getCoordinatorsSucceed,
  getCoordinatorsFailed,
  getAdminFleetsSucceed,
  getAdminFleetsFailed,
  uploadVehiclesSucceed,
  uploadVehiclesFailed,
  editCategorySubcategorySucceed,
  editCategorySubcategoryFailed,
  uploadMassChangeSucceeded,
  uploadMassChangeFailed,
} from './actions';

export function* getListOfContractsSaga(action) {
  try {
    yield put(showLoader());
    const data = yield call(getListOfContractsService, action.payload);
    yield put(getContractsSucceed(data));
  } catch (error) {
    yield put(getContractsFailed(error));
  } finally {
    yield put(hideLoader());
  }
}

export function* getContractsFiltersSaga() {
  try {
    yield put(showLoader());
    const data = yield call(getContractsFiltersService);
    yield put(getContractsFiltersSucceed(data));
  } catch (error) {
    yield put(getContractsFiltersFailed(error));
  } finally {
    yield put(hideLoader());
  }
}

export function* saveContractSaga(action) {
  try {
    yield put(showLoader());
    const data = yield call(postContract, action.payload);
    yield put(saveContractSucceed(data));
  } catch (error) {
    yield put(saveContractFailed(error));
  } finally {
    yield put(hideLoader());
  }
}

export function* getContractDetailsSaga(action) {
  try {
    yield put(showLoader());
    const data = yield call(getContractDetails, action.payload);
    yield put(getContractDetailsSucceed(data));
    const loanAndTransferParams = {
      uuid: action.payload.uuid,
      withLoader: false,
    };
    const contractVehiclesParams = yield select(
      (state) => state.contracts.contractVehicles.params
    );
    yield all([
      getContractVehiclesSaga({
        payload: { params: contractVehiclesParams, ...loanAndTransferParams },
      }),
    ]);
  } catch (error) {
    yield put(getContractDetailsFailed(error));
  } finally {
    yield put(hideLoader());
  }
}

export function* getContractVehiclesSaga({ payload }) {
  const { withLoader = true } = payload;
  try {
    if (withLoader) yield put(showLoader());
    const data = yield call(fetchContractVehicles, {
      uuid: payload.uuid,
      params: payload.params,
    });
    yield put(getContractVehiclesSucceed(data));
  } catch (error) {
    yield put(getContractVehiclesFailed(error));
  } finally {
    if (withLoader) yield put(hideLoader());
  }
}

export function* changeOfVehicleSaga(action) {
  try {
    yield put(showLoader());
    const data = yield call(postChangeOfVehicle, action.payload);
    const contractDetailsData = yield call(getContractDetails, {
      uuid: action.payload.uuid,
    });
    yield put(getContractDetailsSucceed(contractDetailsData));
    yield put(changeOfVehicleSucceed(data));
  } catch (error) {
    yield put(changeOfVehicleFailed(error));
  } finally {
    yield put(hideLoader());
  }
}

export function* createLoanSaga(action) {
  try {
    yield put(showLoader());
    const data = yield call(postCreateLoan, action.payload);
    yield put(createLoanSucceed(data));
  } catch (error) {
    yield put(createLoanFailed(error));
  } finally {
    yield put(hideLoader());
  }
}

export function* editCategorySubcategorySaga(action) {
  try {
    yield put(showLoader());
    const data = yield call(postEditCategorySubcategory, action.payload);
    yield put(editCategorySubcategorySucceed(data));
  } catch (error) {
    yield put(editCategorySubcategoryFailed(error));
  } finally {
    yield put(hideLoader());
  }
}

export function* updateContractSaga(action) {
  try {
    yield put(showLoader());
    const data = yield call(putContract, action.payload);
    yield put(updateContractSucceed(data));
  } catch (error) {
    yield put(updateContractFailed(error));
  } finally {
    yield put(hideLoader());
  }
}
export function* getManagersSaga(action) {
  try {
    const data = yield call(getManagers, action.payload);
    yield put(getManagersSucceed(data));
  } catch (error) {
    yield put(getManagersFailed(error));
  }
}

export function* getCoordinatorsSaga(action) {
  try {
    const data = yield call(getCoordinators, action.payload);
    yield put(getCoordinatorsSucceed(data));
  } catch (error) {
    yield put(getCoordinatorsFailed(error));
  }
}

export function* getAdminFleetsSaga(action) {
  try {
    const data = yield call(getAdminFleets, action.payload);
    yield put(getAdminFleetsSucceed(data));
  } catch (error) {
    yield put(getAdminFleetsFailed(error));
  }
}

export function* downloadTemplateVCSaga(action) {
  yield call(downloadTemplateForVCMassiveLoad, action.payload);
}

export function* uploadVehiclesSaga(action) {
  try {
    const data = yield call(uploadVehicles, action.payload, getOptionsAuth());

    if (!data.success) {
      yield put(uploadVehiclesFailed(data));
    } else {
      console.log('response data', data.data);
      yield put(uploadVehiclesSucceed(data));
    }
  } catch (error) {
    console.error('Error in uploadVehiclesSaga:', error);
    yield put(uploadVehiclesFailed(error));
  }
}

export function* downloadFailedRecordsSaga() {
  const getFile = (state) => state.contracts.massiveRecords.file;
  const file = yield select(getFile);

  yield call(downloadRecords, file, getOptionsAuth());
}

export function* downloadVehiclesChangeTemplateSaga(action) {
  yield call(downloadVehiclesChangeTemplate, action.payload);
}

export function* uploadMassiveChangeSaga(action) {
  try {
    const massiveChangeType = yield select(
      (state) => state.contracts.massiveChangeType
    );

    const data = yield call(
      uploadMassiveChange,
      action.payload,
      getOptionsAuth(),
      massiveChangeType
    );

    if (data.success) {
      yield put(uploadMassChangeSucceeded(data));
    } else {
      yield put(uploadMassChangeFailed(data));
    }
  } catch (error) {
    yield put(uploadMassChangeFailed(error));
  }
}

export function* downloadMassiveChangeFailedRecordsSaga() {
  const getFile = (state) => state.contracts.massiveChangeRecords.file;
  const file = yield select(getFile);

  yield call(downloadMassiveChangeRecords, file, getOptionsAuth());
}
